import { c as _c } from "react/compiler-runtime";
import { cn } from '@/lib/utils';
import { Check } from '@/components/ui/icons/Icons';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { ComponentPropsWithoutRef, Ref } from 'react';
type CheckboxProps = ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & {
  ref?: Ref<HTMLButtonElement>;
};
function Checkbox(t0) {
  const $ = _c(11);
  let className;
  let props;
  let ref;
  if ($[0] !== t0) {
    ({
      className,
      ref,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = ref;
  } else {
    className = $[1];
    props = $[2];
    ref = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("flex size-4 items-center justify-center cursor-pointer rounded border border-input shadow-sm transition-colors bg-white hover:border-[#1F84FF] focus:outline-none disabled:hover:border-input disabled:cursor-default", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <CheckboxPrimitive.Indicator><Check className="size-3 text-primary" /></CheckboxPrimitive.Indicator>;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== props || $[8] !== ref || $[9] !== t1) {
    t3 = <CheckboxPrimitive.Root ref={ref} className={t1} {...props}>{t2}</CheckboxPrimitive.Root>;
    $[7] = props;
    $[8] = ref;
    $[9] = t1;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}
Checkbox.displayName = CheckboxPrimitive.Root.displayName;
export { Checkbox };